import NextImage, { ImageProps as NextImageProps } from 'next/image'
import { Box } from '@mui/material'
import { CustomStyles, getStyles } from '@utils/styles'
import defaultStyles, { StylesClassNames } from './styles'

export type ImageProps = NextImageProps & {
  customStyles?: CustomStyles<StylesClassNames>
}

export function Image({
  width = 0,
  height = 0,
  customStyles,
  sizes = '(max-width: 600px) 100vw, 50vw',
  unoptimized,
  src,
  ...rest
}: ImageProps) {
  const styles = getStyles(defaultStyles, customStyles)
  const isNonOptimizableSource =
    typeof src === 'string' &&
    (src.startsWith('data:') || src.toLowerCase().endsWith('.svg'))

  return (
    <Box {...styles('wrapper')}>
      <NextImage
        width={width}
        height={height}
        src={src}
        {...rest}
        sizes={sizes}
        unoptimized={unoptimized ?? isNonOptimizableSource}
      />
    </Box>
  )
}
